import { useMemo, useState } from 'react'
import Swal from 'sweetalert2'
import OsobaService from '@/services/OsobaService'

export default function useOsobaModal(loadData) {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [editingItem, setEditingItem] = useState(null)
	const [formImieINazwisko, setFormImieINazwisko] = useState('')
	const [formFunkcja, setFormFunkcja] = useState('')
	const [formTelefon, setFormTelefon] = useState('')
	const [formEmail, setFormEmail] = useState('')
	const [formPlacowkaId, setFormPlacowkaId] = useState(null)
	const [formPlacowkaName, setFormPlacowkaName] = useState('')
	const [isSaving, setIsSaving] = useState(false)
	const [isPlacowkaSelectOpen, setIsPlacowkaSelectOpen] = useState(false)

	const openCreateModal = (presetPlacowka = null) => {
		setEditingItem(null)
		setFormImieINazwisko('')
		setFormFunkcja('')
		setFormTelefon('')
		setFormEmail('')
		const placowkaId =
			typeof presetPlacowka === 'object'
				? presetPlacowka?._id || presetPlacowka?.id || null
				: presetPlacowka || null
		const placowkaName = typeof presetPlacowka === 'object' ? presetPlacowka?.nazwa || '' : ''
		setFormPlacowkaId(placowkaId)
		setFormPlacowkaName(placowkaName)
		setIsModalOpen(true)
	}

	const openEditModal = item => {
		setEditingItem(item)
		setFormImieINazwisko(item?.imie_i_nazwisko || '')
		setFormFunkcja(item?.funkcja || '')
		setFormTelefon(item?.telefon || '')
		setFormEmail(item?.email || '')
		const placowkaValue = item?.id_placowka
		const placowkaId =
			typeof placowkaValue === 'object' ? placowkaValue?._id || placowkaValue?.id || null : placowkaValue || null
		const placowkaName = typeof placowkaValue === 'object' ? placowkaValue?.nazwa || '' : ''
		setFormPlacowkaId(placowkaId)
		setFormPlacowkaName(placowkaName)
		setIsModalOpen(true)
	}

	const closeModal = () => {
		setIsModalOpen(false)
		setEditingItem(null)
		setFormImieINazwisko('')
		setFormFunkcja('')
		setFormTelefon('')
		setFormEmail('')
		setFormPlacowkaId(null)
		setFormPlacowkaName('')
		setIsPlacowkaSelectOpen(false)
		setIsSaving(false)
	}

	const openPlacowkaSelectModal = () => {
		setIsPlacowkaSelectOpen(true)
	}

	const closePlacowkaSelectModal = () => {
		setIsPlacowkaSelectOpen(false)
	}

	const applyPlacowkaSelection = (placowkaId, placowkaName) => {
		setFormPlacowkaId(placowkaId || null)
		setFormPlacowkaName(placowkaName || '')
		setIsPlacowkaSelectOpen(false)
	}

	const handleSubmit = async e => {
		e.preventDefault()
		const imieINazwisko = formImieINazwisko.trim()
		const funkcja = formFunkcja.trim()
		const telefon = formTelefon.trim()
		const email = formEmail.trim()
		if (!imieINazwisko || !funkcja || !telefon || !formPlacowkaId) return

		setIsSaving(true)
		const payload = {
			imie_i_nazwisko: imieINazwisko,
			funkcja,
			telefon,
			email,
			id_placowka: formPlacowkaId,
		}
		const result = editingItem?._id
			? await OsobaService.update(editingItem._id, payload)
			: await OsobaService.create(payload)

		if (!result?.success) {
			Swal.fire({
				title: 'Error',
				text: result?.error || 'Nie udalo sie zapisac osoby',
				icon: 'error',
			})
			setIsSaving(false)
			return
		}

		closeModal()
		await loadData()
	}

	const handleDelete = async item => {
		const confirm = await Swal.fire({
			title: 'Czy na pewno?',
			text: `Usunac osobe "${item?.imie_i_nazwisko || '-'}"?`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Tak, usun',
			cancelButtonText: 'Anuluj',
		})
		if (!confirm.isConfirmed) return

		const result = await OsobaService.delete(item?._id)
		if (!result?.success) {
			Swal.fire({
				title: 'Error',
				text: result?.error || 'Nie udalo sie usunac osoby',
				icon: 'error',
			})
			return
		}

		await loadData()
	}

	const buttons = useMemo(
		() => [
			{
				type: 'add',
				label: 'Dodaj nowe',
				onClick: openCreateModal,
			},
		],
		[]
	)

	return {
		isModalOpen,
		editingItem,
		formImieINazwisko,
		setFormImieINazwisko,
		formFunkcja,
		setFormFunkcja,
		formTelefon,
		setFormTelefon,
		formEmail,
		setFormEmail,
		formPlacowkaId,
		formPlacowkaName,
		isSaving,
		isPlacowkaSelectOpen,
		openCreateModal,
		openEditModal,
		handleDelete,
		closeModal,
		handleSubmit,
		openPlacowkaSelectModal,
		closePlacowkaSelectModal,
		applyPlacowkaSelection,
		buttons,
	}
}
